export const locales = [
  {
    code: 'nl',
    language: 'nl',
    name: 'Nederlands',
    file: 'nl.lazy.js',
  },
  {
    code: 'es',
    language: 'es',
    name: 'Español',
    file: 'es.lazy.js',
  },
  {
    code: 'fr',
    language: 'fr',
    name: 'Français',
    file: 'fr.lazy.js',
  },
  {
    code: 'de',
    language: 'de',
    name: 'Deutsch',
    file: 'de.lazy.js',
  },
  {
    code: 'en',
    language: 'en',
    name: 'English',
    file: 'en.lazy.js',
  },
]
export const defaultLocale = 'en'
